import React from 'react'

import styles from './VoidItemsHeader.module.scss'

const VoidItemsHeader = ({ reasons, selectedReasonId, entireOrder, onReasonSelected, onEntireOrderToggled, total }) => {
  return (
    <div className={styles.voidItemsHeader}>
      <select name="refund-reason" id="refund-reason" className={styles.refundReason} onChange={(event) => onReasonSelected(event.target.value)} value={selectedReasonId}>
        <option value={''}>Select a reason</option>
        {reasons.map((reason) => <option value={reason.id}>{reason.reason}</option>)}
      </select>
      <div className={styles.entireOrderContainer}>
        <label htmlFor="entire-order-checkbox" className={styles.entireOrderLabel}>Entire Order - {total}</label>
        <input type="checkbox" className={styles.inputCheckbox} name="entire-order-checkbox" id="entire-order-checkbox" checked={entireOrder} onChange={onEntireOrderToggled} />
        <span className={styles.track} onClick={onEntireOrderToggled}>
          <span className={styles.slider}></span>
        </span>
      </div>
    </div>
  )
}

export default VoidItemsHeader
